<template>
      <div class="title_comm transfer_statement_bg mt-0 pt-2 pb-2">
        <button class="back_arrow" type="button" @click="$router.go(-1)">
            <img src="@/assets/images/back_arr.svg" alt="back_arrow" />
        </button>
        <div class="header-page-title">
            <h3>{{$t('withdraw-amount','Withdraw Amount')}}</h3>
        </div>
    </div>

    <section class="withdrawMain-page">

        <div class="payment_op required_f">
            {{$t('please-fill-in-all-fields','Please fill in all required fields')}}*
        </div>
        <div class="bet_body box_shadow payment_opiton w_withdraw_list">
            <ul class="nav nav-pills" id="pills-tab" role="tablist">
                <li class="nav-item" role="presentation" >
                    <button class="nav-link"  :class="{'active': selectedTab === 'new-account'}" @click="selectTab('new-account')" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button"  role="tab" aria-controls="pills-home"  aria-selected="true">
                        {{$t('use-new-acc','Use New Account')}}
                        </button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link"  :class="{'active': selectedTab === 'previous-account'}"  @click="selectTab('previous-account')" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">
                        {{$t('use-prev-acc','Use Previous Account')}}
                    </button>
                </li>
            </ul>
        </div>
        <div class="tab-content" id="pills-tabContent" v-if="selectedTab == 'previous-account'">
            <div class="tab-pane fade show active" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                <!-- for loading  -->
                <div class="divLoader space-height" v-if="loading">
                    <div class="spinner-box">
                        <span class="divspinner"></span>
                    </div>
                    <span class="spinner-text">Loading...</span>
                </div>
                <span class="text-sm_balance mb-4">{{$t('available-to-withdrawal','Available to withdrawal')}}: {{ withdrawlBalance }} </span>
                <div class="forpass withdraw-forget-pass-sec">
                    <a href="Javascript:void(0)" @click="openWithdrawPasswordModal()">
                        {{ $t('forgot-withdraw-password', 'Forgot Withdraw Password') }}?
                    </a>
                </div>
                <template v-if="accountsList.length > 0">
                    <div class="div_outer_box"> 
                        <div class="add_account_box" v-for="(item, index) in accountsList" :key="index" @click="selectCard(index, item.client_account_id)" :class="{'active': selectedCardIndex === index}">
                            <div class="add_account_header" >
                                <div class="bank_type">
                                    <div class="withdraw-img">
                                          {{ item.method_name }}
                                    </div>
                                    <div class="bank_name">
                                        {{ item.bank_id ? item.bank_name : item.payment_type_name }}
                                    </div>
                                </div>
                                <div class="del_acc" @click="(event) => { event.stopPropagation(); openRemoveAccountCOnfirmation(item); }">
                                    <button type="button" class="delt_brn">
                                        <svg width="17" height="16" viewBox="0 0 17 16" fill="#c10931" xmlns="http://www.w3.org/2000/svg">
                                            <path  d="M10.25 11.875C10.5261 11.875 10.75 11.6511 10.75 11.375V6.375C10.75 6.0989 10.5261 5.875 10.25 5.875C9.9739 5.875 9.75 6.0989 9.75 6.375V11.375C9.75 11.6511 9.9739 11.875 10.25 11.875Z"  fill="var(--icon-color-brand-secondary)" ></path>
                                            <path d="M6.75 11.875C7.0261 11.875 7.25 11.6511 7.25 11.375V6.375C7.25 6.0989 7.0261 5.875 6.75 5.875C6.4739 5.875 6.25 6.0989 6.25 6.375V11.375C6.25 11.6511 6.4739 11.875 6.75 11.875Z" fill="var(--icon-color-brand-secondary)"></path>
                                            <path d="M10.5 2.125C10.7761 2.125 11 1.9011 11 1.625C11 1.3489 10.7761 1.125 10.5 1.125H6.5C6.2239 1.125 6 1.3489 6 1.625C6 1.9011 6.2239 2.125 6.5 2.125H10.5Z" fill="var(--icon-color-brand-secondary)"></path>
                                            <path d="M3 2.625C2.7239 2.625 2.5 2.8489 2.5 3.125C2.5 3.4011 2.7239 3.625 3 3.625H3.5V12.825C3.5 13.955 4.42 14.875 5.55 14.875H11.45C12.58 14.875 13.5 13.955 13.5 12.825V3.625H14C14.2761 3.625 14.5 3.4011 14.5 3.125C14.5 2.8489 14.2761 2.625 14 2.625H13H4H3ZM12.5 3.625V12.825C12.5 13.405 12.03 13.875 11.45 13.875H5.55C4.97 13.875 4.5 13.405 4.5 12.825V3.625H12.5Z"fill="#c10931" ></path>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                            <div class="add_account_body">
                                    <div class="user_list">
                                    <ul>
                                        <li v-if="item?.payment_method">
                                            <div class="flex_between" >
                                                <div class="user_details">
                                                    <p> <label> {{ $t('payment-type', 'Payment Type') }}</label>
                                                        <span> : </span>
                                                        <span class="det_user">{{ item?.payment_method }}</span>
                                                    </p>
                                                </div>
                                                <div class="user_details_copy">
                                                    <button type="button"  class="user_id copty_cmn_btn" @click="copyPaymentData($event,this.$t('payment-type', 'Payment Type'), item?.payment_type_name)">
                                                        <img src="@/assets/images/copy.png" alt="">
                                                    </button>
                                                </div>
                                            </div>
                                    
                                        </li>
                                        <li v-if="item?.account_number">
                                            <div class="flex_between" >
                                                <div class="user_details">
                                                    <p> <label> {{ $t('ac-number', 'A/C Number') }}</label>
                                                    <span> : </span>
                                                    <span class="det_user">{{ item?.account_number ? item?.account_number : item?.phone_number }}</span> </p>
                                                </div>
                                                <div class="user_details_copy">
                                                    <button type="button"  class="user_id copty_cmn_btn" @click="copyPaymentData($event,$t('ac-number', 'A/C Number'), item?.account_number)">
                                                        <img src="@/assets/images/copy.png" alt="">
                                                    </button>
                                                </div>
                                            </div>
                                    
                                        </li>
                                        <li v-if="item?.payment_method == 'bank' && item?.ifsc_code">
                                            <div class="flex_between" >
                                                <div class="user_details">
                                                    <p><label>{{ $t('ifsc-code', 'IFSC Code') }}</label> <span> : </span><span class="det_user">
                                                        {{ item?.ifsc_code }}</span> </p>
                                                </div>
                                                <div class="user_details_copy">
                                                    <button type="button"  class="user_id copty_cmn_btn" @click="copyPaymentData($event,$t('ifsc-code', 'IFSC Code'), item?.ifsc_code )">
                                                        <img src="@/assets/images/copy.png" alt="">
                                                    </button>
                                                </div>
                                            </div>
                                    
                                        </li>
                                        <li v-if="item?.payment_method == 'upi'">
                                            <div class="flex_between" v-if="item?.upi_id" >
                                                <div class="user_details">
                                                    <p><label>{{ $t('upi-id', 'UPI ID') }}</label> <span> : </span><span class="det_user">
                                                        {{ item?.upi_id }}</span> </p>
                                                </div>
                                                <div class="user_details_copy">
                                                    <button type="button"  class="user_id copty_cmn_btn" @click="copyPaymentData($event,$t('upi-id', 'UPI ID'), item?.upi_id)">
                                                        <img src="@/assets/images/copy.png" alt="">
                                                    </button>
                                                </div>
                                            </div>
                                    
                                        </li>
                                        <li v-if="item?.payment_method == 'wallet' && item?.crypto_wallet_id">
                                            <div class="flex_between">
                                                <div class="user_details">
                                                    <p><label>{{ $t('wallet-id', 'Wallet ID') }}</label> <span> : </span><span class="det_user">
                                                        {{ item?.crypto_wallet_id }}</span> </p>
                                                </div>
                                                <div class="user_details_copy">
                                                    <button type="button"  class="user_id copty_cmn_btn" @click="copyPaymentData($event,$t('wallet-id', 'Wallet ID'), item?.crypto_wallet_id)">
                                                        <img src="@/assets/images/copy.png" alt="">
                                                    </button>
                                                </div>
                                            </div>
                                    
                                        </li>

                                        <li >
                                            <div class="flex_between" >
                                                <div class="user_details">
                                                    <p> <label>{{ $t('account-holder-name', 'Account Holder’s Name') }}</label> <span> : </span><span class="det_user"> {{ item?.account_holder_name }}</span> </p>
                                                </div>
                                                <div class="user_details_copy">
                                                    <button type="button"  class="user_id copty_cmn_btn" @click="copyPaymentData($event,this.$t('account-holder-name', 'Account Holder’s Name'), item?.account_holder_name)">
                                                        <img src="@/assets/images/copy.png" alt="">
                                                    </button>
                                                </div>
                                            </div>
                                    
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                
                <div class="div_outer_box"  v-if="accountsList && accountsList.length >0">             
                    <div class="pass_change mb-0 withdraw-group">
                        <label for="">{{$t('withdraw-amount','Withdraw Amount')}} <span class="star_req">*</span></label>
                        <div class="position-relative">
                            <input type="tel"  maxlength="10" @input="amount = $helper.sanitizeNumber(+amount, +walletConfig?.withdrawal_range?.max || 99999999)" class="form-control pe-5" :placeholder="$t('enter-amount','Enter Withdrawal Amount')" v-model="amount">
                        </div>
                        <template v-if="v$.amount.$error">
                            <p v-if="v$.amount.required.$invalid" class="error-content">{{ $t('please-enter-amount', 'Please Enter Amount') }}</p>
                        </template>
                        <span class="min_max_text man_max_a ">
                            <span v-if="walletConfig?.withdrawal_range?.min">{{$t('min', 'Min')}}: {{ walletConfig?.withdrawal_range?.min }}</span>
                            <span v-if="walletConfig?.withdrawal_range?.min && walletConfig?.withdrawal_range?.max" class="text-x"> - </span>
                            <span v-if="walletConfig?.withdrawal_range?.max">{{$t('max', 'Max')}}: {{ walletConfig?.withdrawal_range?.max }}</span>
                        </span>
                    </div>
                </div>
                <div class="read_contant op_o pt-1" v-if="accountsList.length > 0">
                    <div class="form-check">
                        <input class="form-check-input" v-model="termCondition" type="checkbox" id="flexCheckDefault" value="" />
                        <span class="agree_with">
                            {{$t('i-have-read-and-agree-with','I Have Read And Agree With')}}
                            <a  @click= "$helper.openModal('#wpolicy-modal-popup')"  class="withdrawal_policy">{{$t('the-terms-of-payment-and-withdrawal-policy','The terms of payment and withdrawal policy')}}</a>
                        </span>
                    </div>
                    <button class="submit_btn" :class="{'btn-disabled' : amount < walletConfig?.withdrawal_range?.min }" type="button" @click="withdrawAmountFuncCall()">{{$t('submit','SUBMIT')}}</button>
                </div>
                
                <div class="user-new_account bet_body box_shadow payment_opiton border-0"  v-else>
                    <svg width="16" height="16" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#bd3726" stroke-width="1" class="size-12"><rect width="16" height="16" id="icon-bound" fill="none"></rect><path d="M7,9h2V4H7V9z M9,11c0-0.553-0.447-1-1-1s-1,0.447-1,1s0.447,1,1,1S9,11.553,9,11z M16,8c0-4.419-3.581-8-8-8S0,3.581,0,8 s3.581,8,8,8S16,12.419,16,8z M14,8c0,1.603-0.625,3.109-1.756,4.244C11.109,13.375,9.603,14,8,14s-3.109-0.625-4.244-1.756 C2.625,11.109,2,9.603,2,8s0.625-3.109,1.756-4.244C4.891,2.625,6.397,2,8,2s3.109,0.625,4.244,1.756C13.375,4.891,14,6.397,14,8z"></path></svg>
                    <p class="user-new_account_text">
                          Oops! Currently there are no accounts found! Please select a
                         <span class="user_fweight">Use New Account</span> option to continue.
                    </p>
                </div>
            </div>            
        </div>
        <div class="bet_body box_shadow payment_opiton"  v-if= "selectedTab == 'new-account'">
            <div class="fill_form">
                <form>
                    <span class="text-sm_balance mb-4">{{$t('available-to-withdrawal','Available to withdrawal')}}: {{ ($auth?.user?.balance + +($auth?.user?.expl || 0)).toFixed(2) }} </span>
                    <div class="withdraw-group">
                        <label for="">{{$t('select-payment-method','Select Payment Method')}}<span class="star_req">*</span></label>
                        <div class="position-relative">
                            <select class="form-select c_bs" placeholder="Select Payment Method" v-model="paymentMethodId" @change="onPaymentMethodChange()">
                                  <option value="null">---{{ $t('select-payment-method', 'Select Payment Method') }}---</option>
                                <option v-for="(item, index) in paymentMethodList" :key="index" :value="item.id" >
                                    {{ item.method_name }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <template v-if="type === 'bank'">
                        <div class="withdraw-group" v-if="filteredBankList">
                            <div class="bank-select">
                                <label for="">{{$t('bank-name','Bank Name')}}<span class="star_req">*</span></label>
                                <div class="dropdown bank-dropdown">
                                    <input type="text" v-model="searchBank" :placeholder="$t('select-bank-name','Select Bank Name')"class="bank-dropdown-input form-select" data-bs-toggle="dropdown" aria-expanded="false"  />
                                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                        <li v-for="(item, index) in filteredBankList" :key="index" v-if="filteredBankList && filteredBankList.length">
                                            <a class="dropdown-item"  @click="selectBank(item)">
                                               {{ item.bank_name }}
                                            </a>
                                        </li>
                                        <li v-else>
                                            <a class="dropdown-item" href="#">
                                                {{$t('no-data-found','No Data Found')}}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <p v-if="v$.accountForm.bankId.$error" class="error-content">{{$t('please-select-bank-name', 'Please Select Bank Name')}}</p>
                        </div>
                        <div class="withdraw-group">
                            <label for="">{{$t('ifsc-Code','IFSC Code')}}<span class="star_req">*</span></label>
                            <div class="fill_con">
                                <input v-model="accountForm.ifscCode" type="text" @input="accountForm.ifscCode = accountForm.ifscCode.toUpperCase()" maxlength="11"  :placeholder="$t('enter-ifsc-code', 'Enter IFSC Code')" class="form-control">
                            </div>
                             <template v-if="v$.accountForm.ifscCode.$error">
                                <p v-if="v$.accountForm.ifscCode.required.$invalid" class="error-content">{{ $t('ifsc-code-is-required', 'IFSC code is required') }}.</p>
                                <p v-if="v$.accountForm.ifscCode.ifscValidator.$invalid" class="error-content">{{ $t('invalid-ifsc','IFSC code should be 11 Alphanumeric Characters') }}</p>
                            </template>
                        </div>
                        <div class="withdraw-group">
                            <label for="">{{$t('account-number','Account Number')}}<span class="star_req">*</span></label>
                                <input v-model="accountForm.accountNumber" type="tel" maxlength="20" :placeholder="$t('enter-ac-Number', 'Enter A/C Number')" class="form-control">
                                <template v-if="v$.accountForm.accountNumber.$error">
                                <p v-if="v$.accountForm.accountNumber.required.$invalid" class="error-content">{{ $t('ac-number-is-required', 'Account Number is required') }}.</p>
                                <p v-if="v$.accountForm.accountNumber.accountNoValidator.$invalid" class="error-content"> {{ $t('invalid-account-number','Account number must be valid numeric value between 9 to 18 digits.') }}</p>
                                </template>
                        </div>
                        <div class="withdraw-group">
                            <label for="">{{$t('account-holder-name','Account Holder Name')}}<span class="star_req">*</span></label>
                            <input type="text" v-model="accountForm.holderName" :placeholder="$t('enter-account-holder-name', 'Enter Account Holder Name')" class="form-control">
                              <template v-if="v$.accountForm.holderName.$error">
                                <p v-if="v$.accountForm.holderName.required.$invalid" class="error-content">{{ $t('account-holder-name-is-required', 'Account holder name is required') }}</p>
                                <p v-else-if="v$.accountForm.holderName.minLength.$invalid || v$.accountForm.holderName.maxLength.$invalid" class="error-content">  {{ $t('min-characters','Account holder name must be 3-100 characters.') }}</p>
                                <p v-if="v$.accountForm.holderName.alphaName.$invalid" class="error-content">{{ $t('only-letters','Must contain only alphabets, spaces, dots, or hyphens.') }}</p>
                                </template>
                        </div>

                    </template>
                    <template v-else>
                        <div class="withdraw-group">
                            <label for="">{{$t('account-holder-name', 'Account Holder’s Name')}}<span class="star_req">*</span></label>
                            <div class="fill_con">
                                <input type="text" v-model="accountForm.holderName" :placeholder="$t('enter-account-holder-name', 'Enter Account Holder Name')" class="form-control">
                            </div>
                            <template v-if="v$.accountForm.holderName.$error">
                                <p v-if="v$.accountForm.holderName.required.$invalid" class="error-content">{{ $t('account-holder-name-is-required', 'Account holder name is required') }}</p>
                                <p v-else-if="v$.accountForm.holderName.minLength.$invalid || v$.accountForm.holderName.maxLength.$invalid" class="error-content">  {{ $t('min-characters','Account holder name must be 3-100 characters.') }}</p>
                                <p v-if="v$.accountForm.holderName.alphaName.$invalid" class="error-content">{{ $t('only-letters','Must contain only alphabets, spaces, dots, or hyphens.') }}</p>
                                </template>
                        </div>
                        <div class="withdraw-group" v-if="type == 'upi'">
                            <label for="">{{$t('upi-id', 'UPI ID')}}</label>
                            <div class="fill_con">
                                    <input v-model="accountForm.upiId" class="form-control profit-input" type="text" :placeholder="$t('enter-upi-id', 'Enter UPI ID')">
                            </div>

                            <template v-if="v$.accountForm.upiId.$error">
                                <p v-if="v$.accountForm.upiId.minLength.$invalid || v$.accountForm.upiId.maxLength.$invalid" class="error-content">{{ $t('upi-length','UPI ID must be 5 to 50 characters.') }}</p>
                                <p v-if="v$.accountForm.upiId.upiValidator.$invalid" class="error-content">{{ $t('upi-format','Must be in the format of name@bank.') }}</p>
                                </template>
                        </div>
                        <div class="withdraw-group" v-if="type == 'wallet'">
                            <label for="">{{$t('wallet-id', 'Wallet ID')}}<span class="star_req">*</span></label>
                            <div class="fill_con">
                                    <input v-model="accountForm.walletId" class="form-control profit-input" type="text" :placeholder="$t('enter-wallet-id', 'Enter wallet ID')">
                            </div>
                            <template v-if="v$.accountForm.walletId.$error">
                                <p v-if="v$.accountForm.walletId.required.$invalid" class="error-content">{{ $t('wallet-id-is-required', 'Wallet ID is required') }}</p>
                                <p v-if="v$.accountForm.walletId.minLength.$invalid || v$.accountForm.walletId.maxLength.$invalid" class="error-content">{{ $t('upi-length','Wallet ID must be 8 to 20 characters.') }}</p>
                                <p v-if="v$.accountForm.walletId.walletValidator.$invalid" class="error-content">{{ $t('wallet-format','Must contain only letters, numbers, @, hyphens, or underscores.') }}</p>
                                </template>
                        </div>
                        <div class="withdraw-group">
                            <label for="">{{$t('choose-file', 'Choose File')}}></label>
                            <div class="fill_con" v-if="!previewImg">
                                <input type="file" class="form-control" @change="fileUpdateFunc" ref="fileInput" id="file" accept=".jpg,.jpeg,.png,.webp"/>
                            </div>
                            <div class="fileList fileList-url" v-if="previewImg">
                                <span class="fileList-cross" @click="removeFile">&#10006;</span>
                                <img :src="previewImg" alt="QR Code Preview" class="preview-image" />
                            </div>
                        </div>
                    </template>
                    <template  v-if="type">
                        <div class="withdraw-group withdraw-password-input">
                            <label for="">{{$t('withdrawal-password', 'Withdrawal Password')}}<span class="star_req">*</span></label>
                            <div class="fill_con">
                                <input :type="isShownWithdrawalPassword ?'text':'password'"  v-model="accountForm.withdrawal_password" @input="accountForm.withdrawal_password = $helper.sanitizeDetails('withdrawPassword', accountForm.withdrawal_password, 20)"  
                                :placeholder="$t('enter-withdrawal-password', 'Enter Withdrawal Password')" class="form-control" />
                                <button type="button" @click="isShownWithdrawalPassword = !isShownWithdrawalPassword" class="btn eye_icon">
                                    <img v-if="!isShownWithdrawalPassword" src="@/assets/images/score-hide-icon.svg" alt="eye-closed">
                                    <img v-else src="@/assets/images/score-visible.svg" alt="eye-open">
                                </button>
                            </div>
                            <p v-if="v$.accountForm.withdrawal_password.$error" class="error-content">{{$t('please-enter-withdraw-password', 'Please Enter Withdraw Password')}}</p>
                            <!-- <button type="button" @click="openWithdrawPasswordModal()" class="btn reset_btn">{{$t('reset', 'Reset')}}</button> -->
                        </div>
                    </template>
                </form>
            </div>
        </div>

        <div class="read_contant op_o" v-if= "selectedTab == 'new-account'">
            <div class="form-check">
                <input class="form-check-input" v-model="accountForm.termCondition" type="checkbox" id="flexCheckDefault" value=""/>
                <span class="agree_with">
                    {{$t('i-have-read-and-agree-with','I Have Read And Agree With')}}
                    <a  @click= "$helper.openModal('#wpolicy-modal-popup')"  class="withdrawal_policy"> {{$t('the-terms-of-payment-and-withdrawal-policy','The terms of payment and withdrawal policy')}} </a>
                </span>
            </div>
            <button class="submit_btn" @click="addAccountServiceCall">{{$t('submit','SUBMIT')}}</button>
        </div>
        <div class="bet_body box_shadow payment_opiton border-0 withdraw_funds_box">
            <div class="payment_op">
                {{$t('withdraw-funds','Withdraw Funds')}}
            </div>
            <div class="guidePoint-details wallet-lang-tabs" id="collapseExample" v-if="hasRules">
                <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                    <template v-for="(value, lang) in walletConfig?.rules?.withdrawal" :key="lang">
                        <li class="nav-item" role="presentation" v-if="value && value?.length > 0">
                            <button class="nav-link" :class="{ active: lang === activeLanguage }" :id="`pills-${lang}-tab`" data-bs-toggle="pill" :data-bs-target="`#pills-${lang}`"
                                type="button" role="tab" :aria-controls="`pills-${lang}`" :aria-selected="lang === activeLanguage" @click="activeLanguage = lang">
                                {{ lang }}
                            </button>
                        </li>
                    </template>
                </ul>
                <div class="tab-content" id="pills-tabContent">
                    <div class="tab-pane fade show active" v-for="(message, lang) in walletConfig?.rules?.withdrawal" 
                        :key="lang" v-show="lang === activeLanguage"   :id="`pills-${lang}`" role="tabpanel" :aria-labelledby="`pills-${lang}-tab`">
                        <div v-for="(point, index) in message" :key="index">
                            <div class="guide-list" v-html="point.description"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="upi_types" v-else>
                <div class="cond_div">
                    <p>1. {{$t('withdrawal-rule-1','This form is for withdrawing the amount from the main wallet only.')}}</p>
                
                    <div class="details_d" :class="[{ 'details_more': showAll }]">
                        <p>
                            2. {{$t('withdrawal-rule-2','The bonus wallet amount cannot be withdrawn by this form.')}}
                        </p>
                        <p>
                            3. {{$t('withdrawal-rule-3','Do not put Withdraw request without betting with deposit amount. Such activity will be identified as Suspicious.')}}
                        </p>
                        <p>
                            4. {{$t('withdrawal-rule-4','If multiple users are using same withdraw account then all the linked users will be blocked.')}}
                        </p>
                        <p>5. {{$t('maximum-withdraw-time-is-45-minutes-then-only-complain','Maximum Withdraw time is 45 minutes then only complain on WhatsApp number.')}}</p>
                        <p>6. {{$t('withdrawal-account-should-be-same-to-deposit-account','Withdrawal account should be same to deposit account.')}}</p>
                    </div>
                    <button class="v_ml" type="button" @click="showAll = !showAll">
                        {{ showAll ? $t('see-less','See Less') : $t('see-more','See More...') }}
                    </button>
                </div>
            </div>
        </div>
        <TutorialVideo type = "3"/>
        <RemoveAccount v-if="selectedRemoveAcc" @yes-click="removeAccountHere()" @close="closeModal()" :item="selectedRemoveAcc"/>
        <RulesModal/>
        <WithdrawalPasswordSetReset ref="withdrawSetReset"/>
    </section>
</template>
<script>
import { defineAsyncComponent } from 'vue';
import {getUserAccounts, withdrawWalletAmount, withdrawAmountClickValidation} from '../services/walletWithdraw';
import {openWithdrawPasswordModal,addAccount} from '../services/withdrawAccountDetails';
import { useVuelidate } from '@vuelidate/core';
import { required, minLength, maxLength, helpers } from '@vuelidate/validators';
import TutorialVideo from '../components/TutorialVideo.vue';
import WithdrawalPasswordSetReset from '../components/WithdrawalPasswordSetReset.vue';
import RulesModal from '../components/RulesModal.vue';
import RemoveAccount from '../components/RemoveAccount.vue';
const alphaName = helpers.withMessage(
  'Must contain only alphabets, spaces, dots, or hyphens.',
  (value) => {
    if (value === null || value === undefined || value === '') return true
    const s = String(value)
    return /^[A-Za-z .-]+$/.test(s)
  }
)
const accountNoValidator = helpers.withMessage(
  'Account number must be valid numeric value between 9 to 18 digits.',
  (value) => {
    if (!value) return true
    return /^[0-9]{9,18}$/.test(String(value))
  }
)
const ifscValidator = helpers.withMessage(
  "Invalid IFSC Code format. It should be 11 alphanumeric characters.",
  (value) => {
    if (!value) return true;
    return /^[a-zA-Z0-9]{11}$/.test(String(value))
  }
)
const upiValidator = helpers.withMessage(
  "Must be in the format of 'name@bank.'",
  (value) => {
    if (!value) return true
    return /^[A-Za-z0-9]+@[A-Za-z0-9]+$/.test(String(value))
  }
)
const walletValidator = helpers.withMessage(
  'Must contain only letters, numbers, hyphens, or underscores.',
  (value) => {
    if (value === null || value === undefined || value === '') return true
    return /^[A-Za-z0-9_@-]+$/.test(String(value))
  }
)
export default {
    name:'Withdrawal',
     setup() {
		return { v$: useVuelidate() }
	},
    inject: ['walletConfig'],
    components:{
        RemoveAccount,
        RulesModal,
        WithdrawalPasswordSetReset,
        TutorialVideo
    },
    data(){
        return{
            paymentMethodId: null,
            selectedTab:'previous-account',
            selectedRemoveAcc: null,
            accountForm: {
                    bankId: null,
                    holderName: '',
                    accountNumber: '',
                    ifscCode: '',
                    upiId: '',
                    walletId: '',
                    file: null,
                    withdrawal_password: null,
                },
            selectedCardIndex: null,
            isShownWithdrawalPassword:false,
            selectBankId: null,
            accountsList: [],
            bankDetailsList: [],
            accountsListData:[],
            selectedAccountData: null,
            showAll: false,
            paymentMethodList: null,
            selectedPaymentMethod: null,
            type:'bank',
            selectedBank: { bank_name : null },
            searchBank: null,
            termCondition: false,
            paymentMethod: null,
            amount :null,
            previewImg:null,
            activeLanguage: null,
        }
    },
    computed: {
        hasRules() {
            if (!this.walletConfig?.rules?.withdrawal) return false;
            return Object.values(this.walletConfig?.rules?.withdrawal).some(arr => arr && arr.length > 0);
        },
        filteredBankList() {            
            if(this.searchBank) {
                const searchTermLower = this.searchBank?.toLowerCase();
                return this.bankDetailsList.filter(item => item.bank_name?.toLowerCase().includes(searchTermLower));
            }
            return this.bankDetailsList
        },
         withdrawlBalance() {
            let { balance = 0, expl = 0 } = this.$auth?.user || {};
            let earnBonus = this.$auth.user.earnBonus || 0;
            return (parseFloat(balance) + parseFloat(expl || 0) - parseFloat(earnBonus)).toFixed(2);
        },
    },
     validations() {
        return {
            accountForm: {
                bankId: this.type === 'bank' ? { required } : {},
                holderName: { 
                    required,
                    minLength: minLength(3),
                    maxLength: maxLength(100),
                    alphaName
                },
                accountNumber:this.type === 'bank' ? { 
                    required,
                    accountNoValidator
                } : {},
                ifscCode: this.type === 'bank' ? { 
                    required,
                    ifscValidator
                } : {},
                upiId: this.type === 'upi' ? { 
                    minLength: minLength(5),
                    maxLength: maxLength(50),
                    upiValidator
                } : {},
                walletId: this.type === 'wallet' ? { 
                    required,
                    minLength: minLength(8),
                    maxLength: maxLength(20),
                    walletValidator    
                } : {},
                withdrawal_password: { required },
            },
            amount:this.selectedTab === 'previous-account' ? { required } : {},
        };
    },
    created() {
        this.selectTab('previous-account');

    },
    mounted(){
        this.bankDetailsList = this.walletConfig?.bank_list;
        const messages = this.walletConfig?.rules?.withdrawal;
        if (messages) {
            this.activeLanguage = Object.entries(messages).find(([lang, rules]) => rules.length > 0)?.[0] || null;
        }
    },
    methods:{
        copyPaymentData(event,catagory, accountData) {
            var input = document.createElement('textarea');
            input.innerHTML = accountData;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);      
            this.$successToast(catagory + ' Copied');
        },

        async withdrawAmountFuncCall() {
             this.v$.$touch()
            if (this.v$.amount.required.$invalid) {
                return
            }
            let isValid = await withdrawAmountClickValidation(this.amount, this.walletConfig, this.withdrawlBalance);
            if (isValid) {
                this.$store.dispatch('setGlobalLoader', true);
                let response = await withdrawWalletAmount(this.amount, this.selectBankId);
                this.$store.dispatch('setGlobalLoader', false);
                if (!response?.error) {
                    this.$router.push('/');
                } else {
                    console.error('Withdrawal error:', response.error);
                }
            }
		},
           selectCard(index, bankId) {
            this.selectedCardIndex = index;
            this.selectBankId = bankId;
        },
        async addAccountServiceCall() {            
            this.v$.$touch()
            if (this.v$.$error) {
                return
            }
            if(this.type === 'upi' && this.accountForm.upiId == '' && this.accountForm.file == null){
                this.$errorToast('At least one field is required UPI ID or QR code.')
                return false;
            }
            let response = await addAccount(this.paymentMethod, this.type, this.accountForm, null)
            if(response){
                this.clearError();  
                this.selectTab('previous-account') 
                this.getAccountDetailList()
            }
        },
        clearError() {
            this.accountForm = {
				bankId: null,
				holderName: '',
				accountNumber: '',
				ifscCode: '',
				upiId: '',
				walletId: '',
				file: null
			},
            this.type = 'bank',
            this.paymentMethodId = null,
            this.errors = {};
            this.selectedBank = null;
            this.searchBank=null,
            this.passwordFieldType = 'password',
            this.accountForm.file = null;
            this.previewImg = null;
            this.amount= null;
        },

           onPaymentMethodChange() {
            const selectedItem = this.paymentMethodList.find(item => item.id === this.paymentMethodId);
            this.getPaymentMethodItem(selectedItem);
            this.paymentMethod = selectedItem
            this.accountForm = {
                ...this.accountForm,
               bankId: null,
				holderName: '',
				accountNumber: '',
				ifscCode: '',
				upiId: '',
				walletId: '',
				file: null,
                withdrawal_password:null,
            };
             this.previewImg = null;
            this.v$.$reset();
             this.searchBank = null;
        },

        getPaymentMethodItem(item) {
            this.type = item?.method_type;
            this.paymentMethodId = item.id;
            this.accountForm.paymentMethodId = item.id;
		    this.accountForm.paymentTypeName = item.name;
        },
        copyToClipboard(catagory, accountForm) {
            var input = document.createElement('textarea');
            input.innerHTML = accountForm;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);      
            this.copiedText = accountForm;
            this.$successToast(catagory + ' Copied');
        },
        selectBank(bank) {
            this.selectedBank = bank;
            this.searchBank = bank?.bank_name;
            this.accountForm.bankId = bank?.id;
        },
        selectTab(tabType){       
            this.selectedTab = tabType;
            if (tabType === 'previous-account') {
                this.getAccountDetailList();
            }
            if (tabType === 'new-account') {
                this.isShownWithdrawalPassword = false;
                this.clearError();
                this.v$.$reset();
            }
        },
        async getAccountDetailList(reconnectTry = 0){
            try{
                let response = await getUserAccounts(this.walletConfig?.payment_method,reconnectTry)
                this.accountsList = response.userAccounts,
                this.paymentMethodList = response.paymentMethods;
                if (this.accountsList.length > 0) {
                    this.selectedCardIndex = 0;
                    this.selectBankId = this.accountsList[0].client_account_id;
                }
            }
            catch(error){
                this.loading = false;
                if (error) {
                    this.$errorToast(error?.[0]);
                }

            }
        },
        openRemoveAccountCOnfirmation(item){
 			this.selectedRemoveAcc = item
			this.$helper.openModal('#delete-acc-popup');

		},
        closeModal() {
			this.selectedRemoveAcc = null;
			this.$helper.closeModal('delete-acc-popup');
		},
        removeAccountHere() {
			this.$helper.closeModal('delete-acc-popup');
            this.selectTab('previous-account')
		},
        fileUpdateFunc(event) {
            try {
                const file = event.target.files[0];
                if (!file.type.startsWith('image/')) {
                    this.$errorToast('Invalid file type. Only JPG, JPEG, PNG, and WEBP image formats are allowed, and file size must be under 5 MB');
                    return;
                }
                const maxSize = 5 * 1024 * 1024; 
                if (file.size > maxSize) {
                    this.$errorToast('Invalid file type. Only JPG, JPEG, PNG, and WEBP image formats are allowed, and file size must be under 5 MB');
                    return;
                }
                this.accountForm.file = file;
                this.previewImg = URL.createObjectURL(this.accountForm.file);
            } catch (e) {
                this.$errorToast(this.$t('try-again-with-different-image', 'Try again with a different image!'));
            }
        },
      removeFile() {
            this.accountForm.file = null;
            this.previewImg = null;
        },
        async openWithdrawPasswordModal(){
            try{
                this.OTPloading = true;
                let response = await openWithdrawPasswordModal()
                this.OTPloading = false;
                if(!response?.error){
                    this.$helper.openModal('#withdrawalPassword');
                    this.$refs.withdrawSetReset.otpHasBeenCalled()
                    this.$refs.withdrawSetReset.resetTimer();
                }else{
                    this.$errorToast(response?.error);
                }
            }
            catch(error){
                this.OTPloading = false;
                if(error) {
                    this.$errorToast(error);
                }
            }
        },
    }
}
</script>